import WarningIcon from '@material-ui/icons/Warning';
import InputAdornment from '@material-ui/core/InputAdornment';
import { BallBeat } from 'react-pure-loaders';
import DialogActions from '@material-ui/core/DialogActions';
import CircularProgress from '@material-ui/core/CircularProgress';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import List from '@material-ui/core/List';
import ListSubheader from '@material-ui/core/ListSubheader';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import PropTypes from 'prop-types';
import React from 'react';
import { hotkeys } from 'react-keyboard-shortcuts';
import { v4 as uuidv4 } from 'uuid';
import DialogMultiActions from '../../core/DialogMultiActions';
import Errored from '../../core/Errored';
import Help from '../../core/Help';
import LabelledSwitch from '../../core/LabelledSwitch';
import PrimaryAddButton from '../../core/PrimaryAddButton';
import PrimaryRepeatButton from '../../core/PrimaryRepeatButton';
import SelectableListResult from '../../core/SelectableListResult';
import { globalStyles } from '../../core/style/gstheme';
import TitledTextField from '../../core/TitledTextField';
import { debounce, makeCancelable, sanitiseText, sortByLength, computeConceptIcon } from '../../core/utils/utils';
import GS from '../../grafsync/grafsync';
import { MAX_CONCEPT_LENGTH } from '../constants';
import SchemeLink from '../core/SchemeLink';
import IRIentry from '../../core/IRIentry';
import { Typography } from '@material-ui/core';

const styles = Object.assign({}, globalStyles);

class CreateConceptDialog extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            open: false,
            acOpen: false,
            checking: false,
            checked: false,
            createAsXL: props.useXL,
            isUnusedLabel: "",
            isDuplicate: false,
            isDeleted: false,
            processingIRI: false,
            useUnusedLabel: false,
            iriTheSame: false,
            label: "",
            resourceIRI: "",
            labelResourceIRI: "",
            computedIRI: "",
            labelComputedIRI: "",
            addedLabels: [],
            uniqueIRI: false,
            uniqueLabelIRI: false,
            viewIRI: false,
            iriRejected: false,
            labelIriRejected: false,
            searchID: null,
            isErrored: null
        };
        this.cancellable = null;
        this.textInput = React.createRef();
    }

    hot_keys = {
        'alt+n': {
            priority: 1,
            handler: () => this.handleClickOpen(),
        }
    };

    handleClickOpen = () => {
        this.setState({ open: true, acOpen: false });
        if (this.props.onOpen) this.props.onOpen();
    };

    handleXLChange = checked => {
        if (checked) {
            const labelIriOptions = Object.assign({
                prependText: this.props.iriOptions.xlOptions.prependText,
                appendText: this.props.iriOptions.xlOptions.shouldAppendText ? this.props.defaultLang : "",
                textSeparator: "-"
            }, this.props.iriOptions);
            const labelComputedIRI = GS.computeIRI(this.props.schemeIRI, this.state.label, this.props.useSlashIRI, this.props.useUuidIRI, labelIriOptions);
            this.setState({ labelComputedIRI, isUnusedLabel: "" });
        }
        this.setState({
            createAsXL: checked,
            ...(checked) && {
                useUnusedLabel: false
            }
        });
    };

    handleUnusedLabelChange = checked => {
        this.setState({
            useUnusedLabel: checked,
            ...(checked) && {
                createAsXL: false
            }
        });
    };

    findUnusedXLlabel = (value, lang) => {
        let searchParts = [
            {
                predicate: "http://www.w3.org/2004/02/skos/core#inScheme",
                value: this.props.schemeIRI
            },
            {
                predicate: "http://www.w3.org/1999/02/22-rdf-syntax-ns#type",
                value: "http://www.w3.org/2008/05/skos-xl#Label"
            },
            {
                predicate: "http://www.w3.org/2008/05/skos-xl#literalForm",
                value: value,
                isText: true
            }
        ];
        this.doAutocomplete(
            {
                graph: [this.props.graph],
                search: searchParts,
                language: lang,
                excludeByPath: [
                    {
                        predicate: "https://graphifi.com/schema/xkos/isXlPrefLabelOf"
                    },
                    {
                        predicate: "https://graphifi.com/schema/xkos/isXlAltLabelOf"
                    },
                    {
                        predicate: "https://graphifi.com/schema/xkos/isXlHiddenLabelOf"
                    }
                ],
                pageSize: 1,
                predicates: [
                    "http://www.w3.org/2008/05/skos-xl#literalForm",
                    "https://grafsync.graphifi.com/schema/gs/pendingDeletion"
                ]
            }
        ).promise
            .then((data) => {
                if (this.cancellable && this.cancellable.isCancelled()) return;
                const isExisting = data.results && data.results.length > 0 ?
                    data.results.find(result => !result.invalid && result.literalForm[lang].toLowerCase() === value.toLowerCase())
                    :
                    null;
                if (isExisting) {
                    this.setState({
                        isUnusedLabel: isExisting.id,
                        unusedLabelForm: isExisting.literalForm[lang],
                        isDeleted: false,
                        useUnusedLabel: true,
                        createAsXL: false,
                        checking: false,
                        checked: true
                    });
                }
                else {
                    this.setState({
                        isUnusedLabel: "",
                        useUnusedLabel: false,
                        isDeleted: false,
                        checking: false,
                        checked: true
                    });
                }
            })
            .catch((e) => {
                if (this.cancellable && !this.cancellable.isCancelled()) this.setState({ isErrored: e });
            });
    };

    findConcept = (value, lang) => {
        if (!this.props.schemeIRI) throw new Error("No scheme supplied to concept search");
        let searchParts = [
            {
                predicate: "http://www.w3.org/1999/02/22-rdf-syntax-ns#type",
                value: ["http://www.w3.org/2004/02/skos/core#Concept"]
            },
            {
                predicate: "http://www.w3.org/2004/02/skos/core#prefLabel",
                value,
                includeExcludeBySimilarity: true
            }
        ];
        let excludeByPath = [];
        if (this.props.sourceIRI) excludeByPath = [
            {
                predicate: "http://www.w3.org/2004/02/skos/core#broader",
                target: this.props.sourceIRI
            },
            {
                predicate: "http://www.w3.org/2004/02/skos/core#narrower",
                target: this.props.sourceIRI
            },
            {
                predicate: "http://www.w3.org/2004/02/skos/core#related",
                target: this.props.sourceIRI
            }
        ];
        if (this.props.isTopConcept) excludeByPath.push(
            {
                predicate: "http://www.w3.org/2004/02/skos/core#topConceptOf",
                target: this.props.schemeIRI
            }
        );
        this.doAutocomplete(
            {
                graph: [this.props.graph],
                search: searchParts,
                excludeBySimilarity: {
                    predicate: "http://www.w3.org/2004/02/skos/core#prefLabel",
                    targetPredicate: "http://www.w3.org/2004/02/skos/core#inScheme",
                    target: this.props.schemeIRI,
                    value
                },
                language: lang,
                includeDeleted: true,
                exclude: [...this.props.exclude],
                excludeByPath: excludeByPath,
                entailment: this.props.optionForXL ? ["propertyChain"] : [],
                predicates: [
                    "http://www.w3.org/2004/02/skos/core#prefLabel",
                    "http://www.w3.org/2004/02/skos/core#inScheme",
                    "http://www.w3.org/2002/07/owl#deprecated",
                    "http://www.w3.org/2004/02/skos/core#topConceptOf",
                    "https://grafsync.graphifi.com/schema/gs/iri",
                    "https://grafsync.graphifi.com/schema/gs/status",
                    "https://grafsync.graphifi.com/schema/gs/pendingDeletion"
                ]
            })
            .promise
            .then((data) => {
                if (this.cancellable && this.cancellable.isCancelled()) return;
                // Ignore 'old' searches
                if (data.uuid && data.uuid !== this.state.searchID) return;
                const sortedResults = data.results && data.results.length > 0 ? sortByLength([...data.results], 'prefLabel', lang) : null;
                this.setState({
                    results: sortedResults,
                    acOpen: data.results && data.results.length > 0 ? true : false
                });
                // It's a duplicate if there is an equivalent label in the in-context scheme
                // This means it cannot be created as a new concept
                const isDuplicate = data.results && data.results.length > 0 ? data.results.some(result => {
                    // We may get an edge case of mutiple prefLabels in a single language
                    if (Array.isArray(result.prefLabel[lang])) {
                        return result.prefLabel[lang].some(label =>
                            label.toLowerCase() === this.state.label.toLowerCase().trim()
                            && ((result.inScheme && result.inScheme.includes(this.props.schemeIRI))
                                || (result.topConceptOf && result.topConceptOf.includes(this.props.schemeIRI))
                                || result.id === this.props.sourceIRI));
                    }
                    return result.prefLabel[lang].toLowerCase() === this.state.label.toLowerCase().trim()
                        && ((result.inScheme && result.inScheme.includes(this.props.schemeIRI))
                            || (result.topConceptOf && result.topConceptOf.includes(this.props.schemeIRI))
                            || result.id === this.props.sourceIRI);
                })
                    :
                    false;
                this.setState({ isDeleted: false, isDuplicate, isUnusedLabel: "" });
                if (!this.props.optionForXL) {
                    this.setState({ checking: false, checked: true });
                }
                else {
                    if (!isDuplicate) {
                        // Text search might not find the exact string, especially for high end Unicode
                        // So test for exactly that string existing
                        this.findExactConcept(value, lang);
                    }
                    else this.setState({ checking: false, checked: true });
                }
            })
            .catch((e) => {
                if (this.cancellable && !this.cancellable.isCancelled()) this.setState({ isErrored: e });
            });
    };

    findExactConcept = (value, lang) => {
        let searchParts = [
            {
                predicate: "http://www.w3.org/2004/02/skos/core#inScheme",
                value: this.props.schemeIRI
            },
            {
                predicate: "http://www.w3.org/1999/02/22-rdf-syntax-ns#type",
                value: ["http://www.w3.org/2004/02/skos/core#Concept"]
            },
            {
                predicate: "http://www.w3.org/2004/02/skos/core#prefLabel",
                value,
                isExactMatch: true
            }
        ];
        this.doAutocomplete(
            {
                graph: [this.props.graph],
                search: searchParts,
                language: lang,
                searchMode: 'Compliant',
                entailment: this.props.optionForXL ? ["propertyChain"] : [],
                predicates: [
                    "http://www.w3.org/2004/02/skos/core#prefLabel"
                ]
            })
            .promise
            .then((data) => {
                if (this.cancellable && this.cancellable.isCancelled()) return;
                const isDuplicate = data.results && data.results.length > 0;
                this.setState({ isDuplicate });
                if (!isDuplicate) {
                    this.findUnusedXLlabel(value, lang);
                }
                else this.setState({ checking: false, checked: true });
            })
            .catch((e) => {
                if (this.cancellable && !this.cancellable.isCancelled()) this.setState({ isErrored: e });
            });
    };

    // We keep a record of added labels to add to duplicate test because quickly added may not have reached DB
    updateAddedLabels = () => {
        this.setState((prevState) => {
            const ALs = [...prevState.addedLabels];
            ALs.push(prevState.label);
            return { addedLabels: ALs };
        });
    };

    loadIDs() {
        this.cancellable = makeCancelable(this.reserveIDs());
        return this.cancellable;
    }

    reserveIDs = async () => {
        this.setState({ processingIRI: true });
        const isFound = await GS.reserveIRI(this.state.resourceIRI, this.props.graph, "http://www.w3.org/2004/02/skos/core#Concept");
        const exists = isFound.exists;
        if (exists) {
            this.rejectIRI(true);
            return false;
        }
        const reservationID = isFound.id;
        let labelReservationID;
        if (this.state.createAsXL) {
            const isLabelFound = await GS.reserveIRI(this.state.labelResourceIRI, this.props.graph, "http://www.w3.org/2008/05/skos-xl#Label");
            const labelExists = isLabelFound.exists;
            if (labelExists) {
                this.rejectLabelIRI(true);
                return false;
            }
            labelReservationID = isLabelFound.id;
        }
        return {
            reservationID,
            labelReservationID
        };
    };

    addConcept = async () => {
        try {
            const ids = await this.loadIDs().promise;
            if (this.cancellable && this.cancellable.isCancelled()) return true;
            if (ids !== false) {
                this.setState({ open: false, acOpen: false }, async () => {
                    await this.processConcept(ids, true);
                });
            }
        }
        catch (e) {
            if (!this.cancellable || (this.cancellable && !this.cancellable.isCancelled())) this.setState({ isErrored: e });
        }
    };

    addConceptPlus = async () => {
        try {
            const ids = await this.loadIDs().promise;
            if (this.cancellable && this.cancellable.isCancelled()) return true;
            if (ids !== false) {
                await this.processConcept(ids);
                this.textInput && this.textInput.current && this.textInput.current.focus();
            }
        }
        catch (e) {
            if (!this.cancellable || (this.cancellable && !this.cancellable.isCancelled())) this.setState({ isErrored: e });
        }
    };

    processConcept = async (ids, close = false) => {
        // We need to make sure we have the parent loaded so narrower events happens
        const { reservationID, labelReservationID } = ids;
        await this.loadData([this.props.parentIRI], {}, this.props.graph).promise;
        if (this.cancellable && this.cancellable.isCancelled()) return true;
        this.updateAddedLabels();
        const { property, parentIRI } = this.props;
        const { label, resourceIRI, createAsXL, useUnusedLabel, isUnusedLabel, labelResourceIRI } = this.state;
        this.setState({
            label: "",
            acOpen: false,
            checking: false,
            checked: false,
            isUnusedLabel: "",
            isDuplicate: false,
            processingIRI: false,
            createAsXL: this.props.useXL,
            uniqueIRI: false,
            uniqueLabelIRI: false,
            iriRejected: false,
            labelIriRejected: false,
            iriTheSame: false,
            viewIRI: false,
            resourceIRI: "",
            computedIRI: "",
            labelResourceIRI: "",
            labelComputedIRI: ""
        }, () => {
            if (close) {
                this.props.onClose && this.props.onClose();
            }
            setTimeout(async () => {
                // This is async but we don't wait for it
                this.props.onAddNewConcept(property, parentIRI, label.trim(), reservationID, resourceIRI,
                    createAsXL, labelReservationID, useUnusedLabel ?
                    isUnusedLabel
                    :
                    createAsXL ?
                        labelResourceIRI
                        :
                        null);
            }, 10);
        });
    };

    loadData(iris, options, graph) {
        this.cancellable = makeCancelable(
            GS.loadData(iris, options, graph, true)
        );
        return this.cancellable;
    }

    exitAddConcept = () => {
        if (this.hcTimeout) clearTimeout(this.hcTimeout);
        this.setState({
            open: false,
            label: "",
            checking: false,
            checked: false,
            acOpen: false,
            isUnusedLabel: "",
            isDeleted: false,
            isDuplicate: false,
            uniqueIRI: false,
            uniqueLabelIRI: false,
            iriTheSame: false,
            processingIRI: false,
            viewIRI: false,
            iriRejected: false,
            labelIriRejected: false,
            computedIRI: "",
            labelComputedIRI: "",
            resourceIRI: "",
            labelResourceIRI: "",
            useUnusedLabel: false,
            createAsXL: false
        });
        this.props.onClose && this.props.onClose();
    };

    insertExistingConcept = (childIRI) => {
        this.props.onAddExistingConcept(this.props.parentIRI, this.props.property, childIRI);
        this.exitAddConcept();
    };

    processChange = (text, lang) => {
        if (this.state.addedLabels.includes(text)) {
            this.setState({ isDuplicate: true, checking: false, checked: true });
            this.handleClickAway();
        }
        else this.findConcept(text, lang);
    };

    handleChange = (lang) => (event) => {
        const t = event.target;
        const cleanText = sanitiseText(t.value.trimLeft());
        this.setState({ label: cleanText, isDuplicate: false, checking: true, checked: false, acOpen: false });
        if (cleanText.length > 0) {
            if (!this.props.useUuidIRI || this.state.computedIRI === "") {
                try {
                    const computedIRI = GS.computeIRI(this.props.schemeIRI, cleanText, this.props.useSlashIRI, this.props.useUuidIRI, this.props.iriOptions);
                    this.setState({ computedIRI });
                    if (!this.state.isUnusedLabel && this.state.createAsXL) {
                        const labelIriOptions = Object.assign({
                            prependText: this.props.iriOptions.xlOptions.prependText,
                            appendText: this.props.iriOptions.xlOptions.shouldAppendText ? this.props.defaultLang : "",
                            textSeparator: "-"
                        }, this.props.iriOptions);
                        const labelComputedIRI = GS.computeIRI(this.props.schemeIRI, cleanText, this.props.useSlashIRI, this.props.useUuidIRI, labelIriOptions);
                        this.setState({ labelComputedIRI });
                    }
                }
                catch (e) {
                    if (!this.cancellable || (this.cancellable && !this.cancellable.isCancelled())) this.setState({ isErrored: e });
                }
            }
            debounce(this.processChange, this, [cleanText, lang]);
        }
        else {
            // We set a search ID so all inflight searches are ignored for empty text
            const searchID = uuidv4();
            if (this.hcTimeout) clearTimeout(this.hcTimeout);
            this.setState({
                searchID,
                checking: false,
                checked: true,
                isDuplicate: false,
                useUnusedLabel: false,
                isUnusedLabel: "",
                computedIRI: "",
                labelComputedIRI: ""
            });
            this.handleClickAway();
        }
    };

    resetIRIconfirmation = () => this.setState({ uniqueIRI: false, iriRejected: false });

    confirmUniqueIRI = (iri) => {
        this.setState({ uniqueIRI: true, iriRejected: false, resourceIRI: iri, iriTheSame: iri === this.state.labelResourceIRI });
    };

    rejectIRI = () => this.setState({ uniqueIRI: false, iriRejected: true, processingIRI: false });

    resetLabelIRIconfirmation = () => this.setState({ uniqueLabelIRI: false, labelIriRejected: false });

    confirmLabelUniqueIRI = (iri) => {
        this.setState({ uniqueLabelIRI: true, labelIriRejected: false, labelResourceIRI: iri, iriTheSame: iri === this.state.resourceIRI });
    };

    rejectLabelIRI = () => this.setState({ uniqueLabelIRI: false, labelIriRejected: true, processingIRI: false });

    handleInvalidSelection = (label) => {
        this.setState({ label: label, checking: true, checked: false, acOpen: false });
        this.handleClickAway();
        debounce(this.processChange, this, [label, this.props.defaultLang]);
    };

    doAutocomplete(payload) {
        if (this.cancellable && this.cancellable.isCancelled()) return;
        const searchID = uuidv4();
        this.setState({ searchID });
        this.cancellable = makeCancelable(GS.autocomplete(payload, searchID));
        return this.cancellable;
    }

    componentWillUnmount() {
        if (this.cancellable) this.cancellable.cancel();
        if (this.hcTimeout) clearTimeout(this.hcTimeout);
    }

    handleClickAway = () => this.setState({ acOpen: false });

    // So not sure but for child concepts the click away listener doesn't seem to work
    // This workaround seems to do it
    dialogClick = () => this.setState({ acOpen: false });

    handleShowChange = checked => this.setState({ viewIRI: checked });

    render() {

        const { label, acOpen, isErrored, results, isDuplicate, isDeleted, computedIRI, uniqueIRI,
            uniqueLabelIRI, labelComputedIRI, labelIriRejected,
            addedLabels, useUnusedLabel, createAsXL, checking, checked, isUnusedLabel, processingIRI, iriRejected, iriTheSame } = this.state;
        const { classes, optionForXL, button, title, defaultLang, useSlashIRI, useUuidIRI, useWorkflow,
            schemeIRI, placeholder, disableMultiple, graph, iriOptions } = this.props;

        const viewIRI = iriOptions.showIRI || this.state.viewIRI;

        if (isErrored) return <Errored data={isErrored} />;

        const invalid = label.length === 0 || isDuplicate || checking || (createAsXL && iriTheSame)
            || !checked || isDeleted || !uniqueIRI || (createAsXL && !uniqueLabelIRI);

        return (
            <React.Fragment>
                <span data-test="add-concept" onClick={this.handleClickOpen}>{button}</span>
                {this.state.open &&
                    <Dialog
                        data-test="add-concept-dialog"
                        onClick={this.dialogClick}
                        maxWidth="md"
                        fullWidth
                        classes={{
                            paper: classes.paper,
                            paperWidthMd: classes.largeDialog,
                        }}
                        className={classes.dialog}
                        open={this.state.open}
                        onClose={this.exitAddConcept}
                        aria-labelledby="createconcept-dialog-title">
                        <DialogTitle disableTypography className={classes.mainHeading} id="createconcept-dialog-title">{title}</DialogTitle>
                        <DialogContent style={{
                            height: optionForXL ?
                                viewIRI ?
                                    createAsXL ?
                                        '480px'
                                        :
                                        isUnusedLabel ?
                                            '380px'
                                            :
                                            '320px'
                                    :
                                    isUnusedLabel ?
                                        '270px'
                                        :
                                        '220px'
                                :
                                viewIRI ?
                                    '280px'
                                    :
                                    isUnusedLabel ?
                                        '300px'
                                        :
                                        '160px'
                        }}>
                            <Help textRef="ADD_TOP_CONCEPT" />
                            <form autoComplete="off" noValidate="novalidate">
                                <TitledTextField
                                    dataTest="concept-label"
                                    name="label"
                                    inputRef={this.textInput}
                                    disabled={processingIRI}
                                    title={createAsXL ? "Literal Form" : "Preferred Label"}
                                    autoFocus={true}
                                    required={true}
                                    text={label}
                                    placeholder={placeholder || "Text"}
                                    maxLength={MAX_CONCEPT_LENGTH}
                                    lang={defaultLang}
                                    adornment={
                                        checking ?
                                            <Tooltip title="Searching for results">
                                                <CircularProgress data-test="searching-for" color="secondary" size={20} />
                                            </Tooltip>
                                            :
                                            iriRejected || labelIriRejected ?
                                                <InputAdornment position="end">
                                                    <Tooltip title="There is an IRI clash">
                                                        <WarningIcon data-test="warning" />
                                                    </Tooltip>
                                                </InputAdornment>
                                                :
                                                null
                                    }
                                    helperText={addedLabels.includes(label.trim()) ?
                                        "You added this value recently."
                                        :
                                        (isUnusedLabel || isDeleted) ?
                                            (isUnusedLabel ?
                                                "This value exists as an unused SKOS-XL label (" + this.state.unusedLabelForm + ")."
                                                :
                                                "This values exists as a deleted SKOS-XL label."
                                            )
                                            :
                                            isDuplicate && !acOpen ?
                                                "This value already exists"
                                                :
                                                null
                                    }
                                    onEnter={!isDuplicate && checked ? this.addConcept : null}
                                    onCtrlEnter={!isDuplicate && checked ? this.addConceptPlus : null}
                                    onChange={this.handleChange(defaultLang)} />
                                {acOpen &&
                                    <ClickAwayListener onClickAway={this.handleClickAway}>
                                        <List
                                            data-test="list-results"
                                            dense
                                            className={classes.existingResults}
                                            subheader={<ListSubheader className={classes.existingResultsHeader}>Existing Concepts</ListSubheader>}
                                            style={{ marginTop: -8 }}>
                                            {results && results.map((result, i) => {
                                                let resultLabel = Array.isArray(result.prefLabel[defaultLang]) ?
                                                    result.prefLabel[defaultLang].sort().join(" AND ")
                                                    :
                                                    result.prefLabel[defaultLang];
                                                let additionalLabel = null;
                                                if (result.inScheme && !result.inScheme.includes(schemeIRI)) {
                                                    additionalLabel = <div>
                                                        {result.inScheme.map(scheme =>
                                                            <SchemeLink handleNotAvailable={true} key={scheme} id={scheme} graph={graph} defaultLang={defaultLang} />
                                                        )}
                                                    </div>;
                                                }
                                                else if (result.id === this.props.sourceIRI) {
                                                    additionalLabel = "This is the same as the concept being added to.";
                                                }
                                                else if (isDuplicate && resultLabel.toLowerCase() === label.toLowerCase()) {
                                                    if (result.topConceptOf && result.topConceptOf.includes(schemeIRI)) {
                                                        additionalLabel = "This label is already used as a top concept in this scheme.";
                                                    }
                                                    else {
                                                        additionalLabel = "This label is already in this concept scheme.";
                                                    }
                                                }
                                                const currentIRI = result.iri ?
                                                    result.iri[result.iri.length - 1]
                                                    :
                                                    result.id;

                                                const isInvalid = result.invalid || result.pendingDeletion || result.id === this.props.sourceIRI || result.deprecated;
                                                let listSecondIcon = computeConceptIcon(result, useWorkflow);
                                                return <SelectableListResult
                                                    key={i}
                                                    text={resultLabel}
                                                    iri={currentIRI}
                                                    pendingDeletion={result.pendingDeletion}
                                                    invalid={isInvalid}
                                                    listSecondIcon={listSecondIcon}
                                                    selectable={!isInvalid}
                                                    additionalLabel={additionalLabel}
                                                    onClick={!isInvalid ? () => this.insertExistingConcept(result.id) : null}
                                                />;
                                            })}
                                        </List>
                                    </ClickAwayListener>
                                }
                                {optionForXL &&
                                    <div style={{ textAlign: 'right' }}>
                                        <LabelledSwitch
                                            dataTest="createAsXL"
                                            disabled={invalid || processingIRI}
                                            checked={createAsXL}
                                            handleChange={this.handleXLChange}
                                            label="Create as XL Label" />
                                    </div>
                                }
                                {optionForXL && isUnusedLabel &&
                                    <div style={{ textAlign: 'right' }}>
                                        <LabelledSwitch
                                            dataTest="useUnusedXL"
                                            checked={useUnusedLabel}
                                            handleChange={this.handleUnusedLabelChange}
                                            label="Use Existing Unused Label" />
                                    </div>
                                }
                                {!iriOptions.showIRI &&
                                    <div style={{ textAlign: 'right' }}>
                                        <LabelledSwitch
                                            dataTest="show-iri"
                                            checked={viewIRI}
                                            disabled={label.length === 0 || processingIRI}
                                            handleChange={this.handleShowChange}
                                            label="View/Edit IRI" />
                                    </div>
                                }
                                <IRIentry
                                    title="Concept IRI"
                                    key={computedIRI || "conceptIRI"}
                                    margin={iriOptions.showIRI || false}
                                    disabled={processingIRI}
                                    visible={viewIRI}
                                    startIRI={computedIRI}
                                    useSlashIRI={useSlashIRI}
                                    graph={graph}
                                    resetIRIconfirmation={this.resetIRIconfirmation}
                                    confirmUniqueIRI={this.confirmUniqueIRI}
                                    rejectIRI={this.rejectIRI}
                                    useUuidIRI={useUuidIRI}
                                />
                                {optionForXL && !useUnusedLabel && createAsXL &&
                                    <React.Fragment>
                                        <IRIentry
                                            title="Label IRI"
                                            margin={true}
                                            visible={viewIRI}
                                            dataTest="label-iri-entry-field"
                                            disabled={processingIRI}
                                            handleIRIclash={iriOptions.handleIRIclash}
                                            key={labelComputedIRI || "labelIRI"}
                                            startIRI={labelComputedIRI}
                                            useSlashIRI={useSlashIRI}
                                            graph={graph}
                                            resetIRIconfirmation={this.resetLabelIRIconfirmation}
                                            confirmUniqueIRI={this.confirmLabelUniqueIRI}
                                            rejectIRI={this.rejectLabelIRI}
                                            useUuidIRI={useUuidIRI}
                                        />
                                        {iriTheSame && viewIRI && <Typography data-test="two-iris" variant="caption">The two IRIs must be different.</Typography>}
                                    </React.Fragment>
                                }
                            </form>
                        </DialogContent>
                        {processingIRI ?
                            <DialogActions className={classes.dialogActions}>
                                <div style={{ display: 'flex', height: 40 }}>
                                    <Typography className={classes.subMainHading}>Processing ...</Typography>
                                    <span style={{ marginLeft: 24 }}>
                                        <BallBeat color='#97d700' loading={true} />
                                    </span>
                                </div>
                            </DialogActions>
                            :
                            <DialogMultiActions onCancel={this.exitAddConcept}>
                                <PrimaryAddButton title="Add a concept" disabled={invalid || processingIRI} onClick={this.addConcept} />
                                {!disableMultiple &&
                                    <PrimaryRepeatButton
                                        dataTest="add-multiple-concepts"
                                        title="Add concept and create another (Ctrl+Enter)"
                                        disabled={invalid || processingIRI}
                                        onClick={this.addConceptPlus} />
                                }
                            </DialogMultiActions>
                        }
                    </Dialog>
                }
            </React.Fragment>
        );
    }
}

CreateConceptDialog.defaultProps = {
    disableMultiple: false,
    exclude: [],
    useXL: false,
    useWorkflow: false,
    isTopConcept: false,
    iriOptions: {}
};

CreateConceptDialog.propTypes = {
    onOpen: PropTypes.func,
    isTopConcept: PropTypes.bool.isRequired,
    graph: PropTypes.string.isRequired,
    optionForXL: PropTypes.bool,
    useXL: PropTypes.bool,
    useWorkflow: PropTypes.bool,
    onClose: PropTypes.func,
    useSlashIRI: PropTypes.bool,
    useUuidIRI: PropTypes.bool,
    sourceIRI: PropTypes.string,
    parentIRI: PropTypes.string,
    exclude: PropTypes.array,
    disableMultiple: PropTypes.bool,
    schemeIRI: PropTypes.string.isRequired,
    projectIRI: PropTypes.string.isRequired,
    defaultLang: PropTypes.string.isRequired,
    property: PropTypes.string.isRequired,
    placedholder: PropTypes.string,
    onAddExistingConcept: PropTypes.func.isRequired,
    onAddNewConcept: PropTypes.func.isRequired,
    classes: PropTypes.object,
    iriOptions: PropTypes.object
};

export default withStyles(styles)(hotkeys(CreateConceptDialog));